function initializeTabs() {
  const tabs = document.querySelectorAll('.custom-tab');
  const tabContents = document.querySelectorAll('.custom__tab-content');

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      const contentId = this.dataset.contentId;
      const content = document.getElementById(contentId);

      tabContents.forEach(function (content) {
        content.classList.remove('active');
      });

      tabs.forEach(function (tab) {
        tab.classList.remove('active');
      });

      this.classList.add('active');
      content.classList.add('active');
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initializeTabs();
});

const observer = new MutationObserver(initializeTabs);
observer.observe(document.body, {
  childList: true,
  subtree: true,
});
